import React from "react";

const FindMore = () => {
	return (
		<section className="find-more text-center dm">
			<div className="container ">
				<h3 className="fw-4">Find out more about how we work</h3>
				<button className="btn cta">How we work</button>
			</div>
		</section>
	);
};

export default FindMore;
